export default __webpack_public_path__ + "static/media/emptyAddressesList.6b0d2b2e.svg";